import { AccountTeamState } from '@layout/account-team/store/states/account-team.state';

export const accountTeamState = [AccountTeamState];
